$(document).ready(function () {
    //abre resumo
    if($('.resumo').length > 0) {
        $('.resumo span').on('click', function (e) {
            e.preventDefault();

            $('.resumo .lista').toggleClass('open');
        });

        $('.resumo .close').on('click', function (e) {
            e.preventDefault();

            $('.resumo .lista').removeClass('open');
        });
    }


    const singleGaleria = () => {
        const singleGal = document.querySelectorAll('.ch-galeria'); // container above slider

        singleGal.forEach(sliderWrapper => {
            const slider = sliderWrapper.querySelector('.gal'); // container with slider
            const controlsContainerD = sliderWrapper.querySelector('.slider-control');

            if(slider) {
                const sliderGal = tns({
                    container: slider,
                    mouseDrag: true,
                    nav: false,
                    loop: false,
                    controlsContainer: controlsContainerD,
                    items: 1,
                });

                sliderGal.events.on('transitionStart', function (info, eventName) {
                    sliderWrapper.querySelector('.here').innerHTML = info.index + 1;
                });
            }
        });
    };

    if($('.ch-galeria').length > 0) {
        singleGaleria();
    }

    //single insta

    if($('#instaModal').length > 0) {
        var myModal = new bootstrap.Modal(document.getElementById('instaModal'));
        var modalElement = document.getElementById('instaModal');

        window.addEventListener('load', function() {
            if (window.location.pathname.startsWith('/instagram/')) {
                myModal.show();
            }
        });

        // Quando o modal for fechado, volta para URL anterior
        modalElement.addEventListener('hidden.bs.modal', function () {
            // if (window.location.pathname.startsWith('/instagram/')) {
            //     history.back();
            // }

            window.location.href = '/instagram/';
        });
    }

    if($(window).width() <= 768) {
        $('.ancora .categoria').on('click', function (e) {
            e.preventDefault();

            $(this).closest('.ancora').find('.lista').slideToggle();
        });
    }
});